// extracted by mini-css-extract-plugin
module.exports = {"button":"_6eb00b8e53--button--aQGn7","loading":"_6eb00b8e53--loading--1v9YT","spinner":"_6eb00b8e53--spinner--2lAH3"};